<template>
  <div>
    <div class="questions-bg">
        <img src="../../../assets/xt_pass.png">
        <p>恭喜您通过答题！</p>
        <p>您是一名棒棒的司机</p>
        <p>请继续按照流程完成报名</p>
        <p class="result">正确率：<span>5/5</span></p>
        <p class="btn" @click="btnClick">下一步</p>
    </div>
  </div>
</template>
<script>
import {uploadExamCheck} from '../../../utils/actions'
export default {
  name: 'Success',
  methods: {
    btnClick (e) {
      uploadExamCheck({
        method: 'driver.signup.exampass',
        id: this.$store.state.id
      }).then(function (res) {
      })
      this.$router.push({name: 'cardIDUpLoad', params: {status: '5'}})
    }
  }
}
</script>
<style lang="scss" scoped>
.questions-bg{
  margin-top: 0.76rem;
  width: 95%;
  margin-left: 2.5%;
  background: #F7F7F7;
  border: 1px solid #EEEFF1;
  border-radius: 0.12rem;
  text-align: center;
  img{
      width: 1.6rem;
      height: 1.42rem;
      margin-top: 0.76rem;
  }
  p{
    width: 100%;
    font-size: 0.28rem;
    color: #19191A;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 0.48rem;
  }
  .result{
    margin-top: 0.82rem;
    span{
      color: #FF5714;
    }
  }
  .btn{
    width: 90%;
    height: 0.92rem;
    line-height: 0.92rem;
    margin:0.6rem 0 0.56rem 5%;
    font-size: 0.3rem;
    color:#FFFFFF;
    border-radius: 2px;
    background-image: linear-gradient(269deg, #3B414D 0%, #262A32 100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit-answer/components/Success.vue